import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as Back } from "../../assets/icons/back.svg";
import Icon from "../icon";
import { theme } from "../../helpers/theme";

interface GoBackButtonProps {
  description: string;
  goToUrl?: string | number;
  close?: string;
}

export const GoBackButton = ({
  description,
  goToUrl,
  close,
}: GoBackButtonProps) => {
  let navigate = useNavigate();

  return (
    <ButtonWraper onClick={() => navigate(-1)}>
      <Icon
        width="20px"
        height="20px"
        noPadding
        icon={<Back width="20px" height="20px" />}
      />
      <Description>{description}</Description>
    </ButtonWraper>
  );
};

export const ButtonWraper = styled.button`
  display: flex;
  border: none;
  align-items: center;
  overflow-wrap: break-word;
  background-color: transparent;
  text-align: left;
  cursor: pointer;
`;

const Description = styled.div`
  padding: 5px 10px;
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: ${theme.fontWeight.normal};
  font-size: 14px;
  line-height: 20px;
  color: ${theme.colors.black_primaryText};
  overflow-wrap: break-word;
`;
